__turbopack_context__.v({
  "benefitCard": "IndustryPageSections-module__6poYSG__benefitCard",
  "benefitGrid": "IndustryPageSections-module__6poYSG__benefitGrid",
  "benefitHeader": "IndustryPageSections-module__6poYSG__benefitHeader",
  "benefitIcon": "IndustryPageSections-module__6poYSG__benefitIcon",
  "benefitTitle": "IndustryPageSections-module__6poYSG__benefitTitle",
  "bodyText": "IndustryPageSections-module__6poYSG__bodyText",
  "bulletList": "IndustryPageSections-module__6poYSG__bulletList",
  "carouselSlide": "IndustryPageSections-module__6poYSG__carouselSlide",
  "carouselTrack": "IndustryPageSections-module__6poYSG__carouselTrack",
  "carouselViewport": "IndustryPageSections-module__6poYSG__carouselViewport",
  "checkIcon": "IndustryPageSections-module__6poYSG__checkIcon",
  "chooseImage": "IndustryPageSections-module__6poYSG__chooseImage",
  "chooseImageWrap": "IndustryPageSections-module__6poYSG__chooseImageWrap",
  "choosePanelGrid": "IndustryPageSections-module__6poYSG__choosePanelGrid",
  "container": "IndustryPageSections-module__6poYSG__container",
  "ctaButton": "IndustryPageSections-module__6poYSG__ctaButton",
  "decoderGrid": "IndustryPageSections-module__6poYSG__decoderGrid",
  "decoderImage": "IndustryPageSections-module__6poYSG__decoderImage",
  "decoderImageWrap": "IndustryPageSections-module__6poYSG__decoderImageWrap",
  "decoderSection": "IndustryPageSections-module__6poYSG__decoderSection",
  "decoderText": "IndustryPageSections-module__6poYSG__decoderText",
  "emptySourceForm": "IndustryPageSections-module__6poYSG__emptySourceForm",
  "eyebrow": "IndustryPageSections-module__6poYSG__eyebrow",
  "figureBackground": "IndustryPageSections-module__6poYSG__figureBackground",
  "figureCaption": "IndustryPageSections-module__6poYSG__figureCaption",
  "figureHoverImage": "IndustryPageSections-module__6poYSG__figureHoverImage",
  "finalCopy": "IndustryPageSections-module__6poYSG__finalCopy",
  "finalEmbeddedForm": "IndustryPageSections-module__6poYSG__finalEmbeddedForm",
  "finalFormCard": "IndustryPageSections-module__6poYSG__finalFormCard",
  "finalGrid": "IndustryPageSections-module__6poYSG__finalGrid",
  "finalQuote": "IndustryPageSections-module__6poYSG__finalQuote",
  "finalSubheading": "IndustryPageSections-module__6poYSG__finalSubheading",
  "finalTitle": "IndustryPageSections-module__6poYSG__finalTitle",
  "formTitle": "IndustryPageSections-module__6poYSG__formTitle",
  "galleryCard": "IndustryPageSections-module__6poYSG__galleryCard",
  "galleryCardSubtitle": "IndustryPageSections-module__6poYSG__galleryCardSubtitle",
  "galleryCardTitle": "IndustryPageSections-module__6poYSG__galleryCardTitle",
  "galleryCarousel": "IndustryPageSections-module__6poYSG__galleryCarousel",
  "galleryHeading": "IndustryPageSections-module__6poYSG__galleryHeading",
  "galleryImage": "IndustryPageSections-module__6poYSG__galleryImage",
  "gallerySection": "IndustryPageSections-module__6poYSG__gallerySection",
  "hoverFigure": "IndustryPageSections-module__6poYSG__hoverFigure",
  "inlineLink": "IndustryPageSections-module__6poYSG__inlineLink",
  "introBody": "IndustryPageSections-module__6poYSG__introBody",
  "introSection": "IndustryPageSections-module__6poYSG__introSection",
  "panelCopy": "IndustryPageSections-module__6poYSG__panelCopy",
  "panelGrid": "IndustryPageSections-module__6poYSG__panelGrid",
  "panelTitle": "IndustryPageSections-module__6poYSG__panelTitle",
  "peachBand": "IndustryPageSections-module__6poYSG__peachBand",
  "resourceBody": "IndustryPageSections-module__6poYSG__resourceBody",
  "resourceCard": "IndustryPageSections-module__6poYSG__resourceCard",
  "resourceCards": "IndustryPageSections-module__6poYSG__resourceCards",
  "resourceIcon": "IndustryPageSections-module__6poYSG__resourceIcon",
  "resourceTitle": "IndustryPageSections-module__6poYSG__resourceTitle",
  "resourcesGrid": "IndustryPageSections-module__6poYSG__resourcesGrid",
  "resourcesSection": "IndustryPageSections-module__6poYSG__resourcesSection",
  "sectionTitle": "IndustryPageSections-module__6poYSG__sectionTitle",
  "sectionTitleWhite": "IndustryPageSections-module__6poYSG__sectionTitleWhite",
  "tabItem": "IndustryPageSections-module__6poYSG__tabItem",
  "tabLink": "IndustryPageSections-module__6poYSG__tabLink",
  "tabLinkActive": "IndustryPageSections-module__6poYSG__tabLinkActive",
  "tabList": "IndustryPageSections-module__6poYSG__tabList",
  "tabPanel": "IndustryPageSections-module__6poYSG__tabPanel",
  "tabPanelActive": "IndustryPageSections-module__6poYSG__tabPanelActive",
  "tabPanels": "IndustryPageSections-module__6poYSG__tabPanels",
  "tabScroller": "IndustryPageSections-module__6poYSG__tabScroller",
  "tabSection": "IndustryPageSections-module__6poYSG__tabSection",
  "whiteBody": "IndustryPageSections-module__6poYSG__whiteBody",
});
